import { useState } from "react";
import { Star, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export const AdminShowcaseButton = ({ restaurant, onToggled }) => {
  const [busy, setBusy] = useState(false);
  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/restaurants/${restaurant.id}/showcase`);
      onToggled(restaurant.id, data.showcase);
      toast.success(data.showcase ? `${restaurant.name} è ora il menù in vetrina sulla home` : "Vetrina home rimossa");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Operazione non riuscita");
    } finally {
      setBusy(false);
    }
  };
  const on = restaurant.showcase;
  return (
    <Button variant="ghost" size="sm" onClick={toggle} disabled={busy} title={on ? "Rimuovi dalla vetrina home" : "Mostra nel telefono della home"}
      className={on ? "text-amber-500 hover:bg-amber-50" : "text-gray-400 hover:bg-gray-100 hover:text-amber-500"} data-testid={`admin-showcase-${restaurant.id}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Star className={`h-4 w-4 ${on ? "fill-amber-400" : ""}`} />}
    </Button>
  );
};
